<div class="row">
  <div class="col-md-6">
    <app-form-group><label>Exemption type</label>
      <app-select [(ngModel)]="exemptionInfo.exemptionType" [options]="exemptionTypes"
                  required placeholder="– Select exemption type –">
      </app-select>
    </app-form-group>
    <app-form-group><label>Name</label>
      <input class="form-control" [(ngModel)]="exemptionInfo.name">
    </app-form-group>
    <app-form-group><label>Municipalities</label>
      <app-multiselect
        [(ngModel)]="exemptionInfo.applicableMunicipalities"
        [options]="allMunicipalities"
        placement="top-end" title="Select municipality" required [hideSelected]="true"
        [formatter]="formatMunicipality"
        [equalsFunction]="municipalitiesHaveTheSameCode"
        [enableSelectAll]="true" [autoSelectOnlyOption]="true">
      </app-multiselect>
    </app-form-group>
    <app-form-group><label>Berth</label>
      <app-multi-search [(ngModel)]="exemptionInfo.berths"
                        [searchFunction]="berthSearchFunction"
                        [inputFormatter]="berthFormatter"
                        [resultFormatter]="berthFormatter"
                        [disabled]="municipalityNotSelected"
                        placeholder="Select applicable berths">
      </app-multi-search>
    </app-form-group>
    <app-form-group>
      <label>General Information</label>
      <textarea class="form-control" [(ngModel)]="exemptionInfo.generalInfo" rows="3" maxlength="2048"></textarea>
    </app-form-group>
  </div>
  <div class="col-md-6">
    @for (municipality of exemptionInfo.applicableMunicipalities; track municipality) {
      <div>
        <app-form-group><label>Considering {{ municipality.name }}</label>
          <textarea class="form-control" [(ngModel)]="municipality.considering"></textarea>
        </app-form-group>
      </div>
    }
  </div>
</div>
